import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StateType } from 'src/redux/reducers';
import { REQUEST_GET_SPORT_DATA_MATCH_STATS } from 'src/redux/reducers/sportData';

import SportDataInput from '../SportDataInput';
import MatchStatsContent from './MatchStatsContent';

type Props = {
  handleImportData: (value: string | PropertyValue[]) => void;
  selectedProperty?: Properties;
};

export default function MatchStats({ handleImportData, selectedProperty }: Props) {
  const dispatch = useDispatch();

  const { matchData } = useSelector((state: StateType) => state.sportData);
  const [fixtureId, setFixtureId] = useState<string>(matchData.data?.fixtureId ?? '');

  useEffect(() => {
    if (!fixtureId) return;

    dispatch({
      type: REQUEST_GET_SPORT_DATA_MATCH_STATS,
      payload: { fx: fixtureId },
    });
  }, [dispatch, fixtureId]);

  if (!matchData.data?.fixtureData?.liveData) {
    return <SportDataInput fixtureId={fixtureId} onChange={setFixtureId} />;
  }

  return (
    <MatchStatsContent
      fixtureData={matchData.data.fixtureData}
      fixtureId={fixtureId}
      handleImportData={handleImportData}
      selectedProperty={selectedProperty}
      onFixtureIdChange={setFixtureId}
    />
  );
}
